import { FormattedMessage } from 'gatsby-plugin-intl';
import * as React from 'react';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';

import { useTheme } from '../../../hooks/useTheme';
import { Flex } from '../../../components/common/Flex';
import { Icon } from '../../../components/common/Icon';
import { IconBox } from '../../../components/common/IconBox';
import { Indent } from '../../../components/common/Indent';
import { StyledText } from '../../../components/common/StyledText';
import { TitleLine } from '../../../components/common/TitleLine';
import styled from 'styled-components';
import { media } from '../../../styles/theme';

const Fasapay = require('../../../styles/static/partners/fasapay.svg');
const Neteller = require('../../../styles/static/partners/neteller.svg');
const Cards = require('../../../styles/static/partners/cards.svg');
const EoFinance = require('../../../styles/static/partners/eof.svg');
const Paxum = require('../../../styles/static/partners/paxum.svg');
const Paypal = require('../../../styles/static/partners/paypal.svg');
const Pm = require('../../../styles/static/partners/pm.svg');
const Ym = require('../../../styles/static/partners/ym.svg');
const Qiwi = require('../../../styles/static/partners/qiwi.svg');
const Skrill = require('../../../styles/static/partners/skrill.svg');
const Upay = require('../../../styles/static/partners/upay.svg');
const Webmoney = require('../../../styles/static/partners/webmoney.svg');
const Wiretransfer = require('../../../styles/static/partners/wiretransfer.svg');

export const ToolsAndPaymentsSystems = () => {
  const theme = useTheme();
  return (
    <Section>
      <Grid>
        <Row>
          <Col xs={12} md={6}>
            <Indent bottom={4} mdBottom={0}>
              <Flex direction='column' align='center'>
                <Indent bottom={1} type='block'>
                  <h2>
                    <StyledText
                      color='textInverted'
                      size='1.8'
                      smSize='2.25'
                      lineHeight='1.2'
                      type='block'
                      align='center'>
                      <FormattedMessage id='homepage.fifthSection.leftTitle' />
                    </StyledText>
                  </h2>
                </Indent>
                <Indent bottom={2} type='block'>
                  <TitleLine width='200px' />
                </Indent>
                <StyledText color='textSecondary' smSize={1.25}>
                  <FormattedMessage id='homepage.fifthSection.lead' />
                </StyledText>
              </Flex>
              <Row bottom='xs'>
                <Col xs={12} sm={6}>
                  <Indent top={2} vertical={0.5}>
                    <Flex align='center'>
                      <Indent right={0.8}>
                        <IconBox>
                          <Icon name='image' width='1.5rem' color={theme.primaryColor} />
                        </IconBox>
                      </Indent>
                      <StyledText
                        color='textInverted'
                        style={{
                          flex: '1 1',
                        }}>
                        <FormattedMessage id='homepage.fifthSection.firstTool' />
                      </StyledText>
                    </Flex>
                  </Indent>
                </Col>
                <Col xs={12} sm={6}>
                  <Indent vertical={0.5}>
                    <Flex align='center'>
                      <Indent right={0.8}>
                        <IconBox>
                          <Icon name='pages' width='1.5rem' color={theme.primaryColor} />
                        </IconBox>
                      </Indent>
                      <StyledText
                        color='textInverted'
                        style={{
                          flex: '1 1',
                        }}>
                        <FormattedMessage id='homepage.fifthSection.secondTool' />
                      </StyledText>
                    </Flex>
                  </Indent>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <Indent vertical={0.5}>
                    <Flex align='center'>
                      <Indent right={0.8}>
                        <IconBox>
                          <Icon name='links' width='1.5rem' color={theme.primaryColor} />
                        </IconBox>
                      </Indent>
                      <StyledText
                        color='textInverted'
                        style={{
                          flex: '1 1',
                        }}>
                        <FormattedMessage id='homepage.fifthSection.thirdTool' />
                      </StyledText>
                    </Flex>
                  </Indent>
                </Col>
                <Col xs={12} sm={6}>
                  <Indent vertical={0.5}>
                    <Flex align='center'>
                      <Indent right={0.8}>
                        <IconBox>
                          <Icon name='widgets' width='1.5rem' color={theme.primaryColor} />
                        </IconBox>
                      </Indent>
                      <StyledText
                        color='textInverted'
                        style={{
                          flex: '1 1',
                        }}>
                        <FormattedMessage id='homepage.fifthSection.fourthTool' />
                      </StyledText>
                    </Flex>
                  </Indent>
                </Col>
              </Row>
            </Indent>
          </Col>
          <Col xs={12} md={6}>
            <Flex direction='column' align='center'>
              <Indent bottom={1} type='block'>
                <h2>
                  <StyledText
                    color='textInverted'
                    size='1.8'
                    smSize='2.25'
                    lineHeight='1.2'
                    type='block'
                    align='center'>
                    <FormattedMessage id='homepage.fifthSection.rightTitle' />
                  </StyledText>
                </h2>
              </Indent>
              <Indent bottom={3} type='block'>
                <TitleLine width='200px' />
              </Indent>
            </Flex>
            <Flex justify='center' align='center'>
              <Indent around={1} top={0.5}>
                <Wiretransfer />
              </Indent>
              <Indent around={1} top={0.5}>
                <EoFinance />
              </Indent>
              <Indent around={1} top={0.5}>
                <Webmoney />
              </Indent>
              <Indent around={1} top={0.5}>
                <Paypal />
              </Indent>
              <Indent around={1} top={0.5}>
                <Qiwi />
              </Indent>
              <Indent around={1} top={0.5}>
                <Ym />
              </Indent>
              <Indent around={1} top={0.5}>
                <Neteller />
              </Indent>
              <Indent around={1} top={0.5}>
                <Skrill />
              </Indent>
              <Indent around={1} top={0.5}>
                <Upay />
              </Indent>
              <Indent around={1} top={0.5}>
                <Pm />
              </Indent>
              <Indent around={1} top={0.5}>
                <Fasapay />
              </Indent>
              <Indent around={1} top={0.5}>
                <Cards />
              </Indent>
            </Flex>
          </Col>
        </Row>
      </Grid>
    </Section>
  );
};

const Section = styled.div`
  background: #252c46;
  padding: 50px 0 175px;

  ${media.sm`padding: 75px 0 175px;`}
`;
